import React from 'react';

const NotFoundPage = () => {
  return <h1>NOT FOUND</h1>;
};

export default NotFoundPage;
